import { isIndianUser } from "@/utils/getCountryCode";
import DownloadNH from "../Common/DownloadNH";
import ExclusiveOffers from "../Common/ExclusiveOffers";
import TravelInsights from "../Common/TravelInsights/TravelInsights";
import MainLayout from "../MainLayout";
import BlogSec1 from "./BlogSec1/BlogSec1";
import BlogSecTravelUpdate from "./BlogSecTravelUpdate/BlogSecTravelUpdate";
import ThingsToDoMonth from "./ThingsToDoMonth/ThingsToDoMonth";
import CommonHeader from "@/Common/CommonHeader/CommonHeader";

export default function Blog({
  initialBlogList = [],
  initialBlogMeta = null,
  initialCategories = [],
  initialMonths = [],
  country = "UAE",
}) {
  return (
    <div>
      <MainLayout hideHeader>
        <CommonHeader
          title=""
          buttonText=""
          buttonLink="#blog-section"
          bgImage={isIndianUser() ? "/assets/images/BlogBannerIndia.webp" : "/assets/images/BlogBanner.webp"}
        />
        <BlogSec1 categories={initialCategories} country={country} />
        <ExclusiveOffers />
        <TravelInsights
          isBlogPage={true}
          initialBlogList={initialBlogList}
          initialBlogMeta={initialBlogMeta}
          country={country}
        />
        <ThingsToDoMonth initialMonths={initialMonths} />
        <BlogSecTravelUpdate />
        <DownloadNH />
      </MainLayout>
    </div>
  );
}
